import type { JSX } from "react";
import { useTranslation } from "react-i18next";
import type { TFunction } from "i18next";

/**
 * Patička okna výběru fotek (jen vícenásobný výběr; řez 05, Kontrakt bod 3): „Zrušit“
 * a „Přidat vybrané (N)“, zakázané při N = 0. `count` je počet vybraných ID (`picked`), ne
 * počet vybraných načtených dlaždic: vybraná fotka může ležet na nenačtené stránce.
 *
 * `PickerFooterView` je čistý pohled bez hooků (`t` v props), aby šel v testu zavolat jako
 * funkce; `PickerFooter` mu jen dodá překlady. Obě tlačítka `type="button"`: okno leží
 * uvnitř `<form>` editoru. Odsazení a horní hranu nese patička sama (zrcadlo záhlaví okna):
 * okno ji vkládá přímo do panelu bez obalu.
 */

export interface PickerFooterProps {
  count: number;
  onCancel: () => void;
  onAdd: () => void;
}

export function PickerFooterView({
  count,
  onCancel,
  onAdd,
  t,
}: PickerFooterProps & { t: TFunction }): JSX.Element {
  return (
    <div className="flex items-center justify-between gap-3 border-t border-gray-200 px-4 py-3 dark:border-gray-700">
      <button
        type="button"
        data-media-picker-cancel=""
        onClick={onCancel}
        className="btn-secondary"
      >
        {t("mediaPicker.footer.cancel")}
      </button>
      <button
        type="button"
        data-media-picker-add=""
        data-count={count}
        disabled={count === 0}
        onClick={onAdd}
        className="btn-primary"
      >
        {t("mediaPicker.footer.add", { count })}
      </button>
    </div>
  );
}

export default function PickerFooter(props: PickerFooterProps): JSX.Element {
  const { t } = useTranslation();
  return <PickerFooterView {...props} t={t} />;
}
